






































import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { mdbContainer } from "mdbvue";
import BudgetWizard from "@/components/budgets/BudgetWizard.vue";
import { MediaQuery as MQ } from '@/MediaQuery';
import { RouterUtils } from "@/router/RouterUtils";

@Component({
  components: {
    BudgetWizard,
    mdbContainer
  }
})
export default class BankBudgets extends mixins(RouterUtils) {
  // TODO wizard stepping them through the deposit, budget process
  // TODO edit an existing budget
  // TODO remove a budget and transfer money to be available

  // budgets: {},
  MQ = MQ;
  showWizard: boolean = false;

  // detect if the $route.hash has changed
  @Watch("$route", { immediate: true, deep: true })
  onRouteHashChange(newRoute: any, oldRoute: any) {
    if (oldRoute === undefined || oldRoute.hash !== newRoute.hash) {
      // console.log('location change', oldVal, newVal, this.$route.hash)
      if (this.$route.hash === "" || this.$route.hash === "#new-budget") {
        this.stepNew();
      }
    }
  }
  /* *** method elements: mixins, methods *** */
  // methods: {
  //   ...mapGetters("bank", ["getAuthorizedActivePersons"]),
  rowStyle(index: number) {
    if (index % 2 === 0) {
      return "background: #f0f0f0";
    }
    return "";
  }
  stepNew() {
    this.showWizard = true;
  }
  /* *** lifecycle elements: created, mounted *** */
  created() {}
  mounted() {
    if (this.$route.hash === "#new-budget") {
      this.stepNew();
    }
  }
}
